import React, { Component}  from 'react';
import loadable from '@loadable/component';
import DefaultLoading from '../../elements/defaultLoading/defaultLoading';

export default loadable((props) => import('./claimAnalysis'), {
    fallback: <DefaultLoading />,
});


// WEBPACK FOOTER //
// ./src/components/routes/claimAnalysis/index.jsx